import { useComputedStyle } from './useComputedStyle';

type ComputableCSSStyleDeclaration = {
  [P in keyof CSSStyleDeclaration]: CSSStyleDeclaration[P] extends string
    ? CSSStyleDeclaration[P]
    : never;
};

export const useComputedValue = ({
  element,
  property,
  defaultValue,
}: {
  element?: Element;
  property: keyof ComputableCSSStyleDeclaration;
  defaultValue: number;
}) => {
  const computedStyle = useComputedStyle(
    element
  ) as ComputableCSSStyleDeclaration;

  if (!computedStyle) {
    return defaultValue;
  }

  return computedStyle ? parseFloat(computedStyle[property]) : defaultValue;
};
